import type {
  CategoryWithStubs,
  KnowledgeBaseItemStub,
} from "models/knowledge-base/knowledge-base";

export type CategoryChild =
  | { kind: "item"; item: KnowledgeBaseItemStub }
  | { kind: "subcategory"; subcategory: CategoryWithStubs };

// Merge a category's direct items and its subcategories into a single list
// ordered by their shared `order` sequence. The layout dialog assigns items and
// subcategories sequential order values within the same parent, so a
// subcategory keeps the exact position the editor gave it among the articles.
export const orderedCategoryChildren = (
  category: CategoryWithStubs,
): CategoryChild[] => {
  const items = (category.items ?? []).map((item) => ({
    order: item.order,
    child: { kind: "item" as const, item },
  }));

  const subcategories = (category.subcategories ?? []).map((subcategory) => ({
    order: subcategory.order,
    child: { kind: "subcategory" as const, subcategory },
  }));

  return [...items, ...subcategories]
    .sort((a, b) => a.order - b.order)
    .map((entry) => entry.child);
};
